(function ($) {





// Variables
// -----------------------------------------------------------------------------

	/* global document, window, LazyLoad, jQuery, getComputedStyle, gsap, CSS
		navigator, Quint, barba, bodyScrollLock, Cookies, Plyr, history, location,
		wpcf7, MutationObserver, wpcf7cf */

	const documentBodyStyle = getComputedStyle(document.body);
	// const mdBreakpoint = documentBodyStyle.getPropertyValue("--md-breakpoint");
	const lgBreakpoint = documentBodyStyle.getPropertyValue("--lg-breakpoint");
	const pageTransitionTime = 1.6;
	let previousWindowWidth;
	let previousWindowWidthForHeight;
	let lazyLoadInstance;
	let windowWidth;
	let autoEyesInterval;
	let blinkingInterval;
	let crossEyed;
	let aspectRatioIsSupported;
	let isPaused = false;
	let previousPageScrollPosition = 0;
	let previousPageScrollPositionSaved = 0;
	let isBack = false;
	let observer;

	const videoPlayerOptions = {
		controls: ["play", "progress", "current-time", "mute", "volume", "fullscreen"],
	};
	const selectricOptions = {
		arrowButtonMarkup: "<b class='selectric-button'></b>",
		expandToItemText: true,
		nativeOnMobile: true,
		onInit: () => {
			$(".selectric-input").wrap("<label class='hidden-text'>Hidden Input</label>");
		},
	};





// Init Lazy Load
// -----------------------------------------------------------------------------

	function initLazyLoad() {
		lazyLoadInstance = new LazyLoad({
			elements_selector: ".lazy",
		});
	}





// Store Campaigns Value and Output in Contact Forms
// -----------------------------------------------------------------------------

	function getParameterByName(name) {
		const editedName = name.replace(/[\[\]]/g, "\\$&"); //eslint-disable-line
		const regex = new RegExp(`[?&]${editedName}(=([^&#]*)|&|#|$)`);
		const results = regex.exec(window.location.href);
		if (!results) return null;
		if (!results[2]) return "";
		return decodeURIComponent(results[2].replace(/\+/g, " "));
	}

	function setCookie(name, value, days) {
		let expires = "";
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = `; expires=${date.toUTCString()}`;
		}
		document.cookie = `${name}=${value || ""}${expires}; path=/`;
	}

	function getCookie(name) {
		const nameEQ = `${name}=`;
		const ca = document.cookie.split(";");
		for (let i = 0; i < ca.length; i += 1) {
			let c = ca[i];
			while (c.charAt(0) === " ") c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	function storeAndOutputCookies() {
		const source = getParameterByName("utm_source");
		const medium = getParameterByName("utm_medium");
		const campaign = getParameterByName("utm_campaign");
		const term = getParameterByName("utm_term");
		const content = getParameterByName("utm_content");

		if ((getCookie("ga_optin")) && (campaign || source || medium || term || content)) {
			Cookies.set("utm_campaign", campaign);
			Cookies.set("utm_source", source);
			Cookies.set("utm_medium", medium);
			Cookies.set("utm_term", term);
			Cookies.set("utm_content", content);
		}

		if ($(".wpcf7-form").length) {
			if (campaign || source || medium || term || content) {
				$(".js-form-language").find("input").val(decodeURI(getCookie("pll_language")));
				$(".js-form-campaign").find("input").val(campaign);
				$(".js-form-source").find("input").val(source);
				$(".js-form-medium").find("input").val(medium);
				$(".js-form-term").find("input").val(term);
				$(".js-form-content").find("input").val(content);
			} else {
				$(".js-form-language").find("input").val(decodeURI(getCookie("pll_language")));
				$(".js-form-campaign").find("input").val(decodeURI(getCookie("utm_campaign")));
				$(".js-form-source").find("input").val(decodeURI(getCookie("utm_source")));
				$(".js-form-medium").find("input").val(decodeURI(getCookie("utm_medium")));
				$(".js-form-term").find("input").val(decodeURI(getCookie("utm_term")));
				$(".js-form-content").find("input").val(decodeURI(getCookie("utm_content")));
			}
		}
	}





// Cookies
// -----------------------------------------------------------------------------

	function googleTracking() {
		/* eslint-disable */
		(function(w, d, s, l, i){
			w[l] = w[l] || [];
			w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
			var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s),
				dl = l != "dataLayer" ? "&l=" + l : "";
			j.async = true;
			j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
			f.parentNode.insertBefore(j, f);
		})(window, document, "script", "dataLayer", "GTM-TR7VMN4");
		/* eslint-enable */
	}

	function optInGoogleTracking() {
		googleTracking();
		setCookie("ga_optin", true, 182);
		storeAndOutputCookies();
	}

	function initCookieBar() {
		if (getCookie("ga_optin")) {
			googleTracking();
		} else if (getCookie("ga_optin") == null) {
			$(".js-cookiebar").show();
		}

		$(document).on("click", ".js-manage-cookies", (event) => {
			event.preventDefault();
			$(".js-cookie-options").slideDown();
			$(".js-cookiebar").slideUp();
		});

		$(document).on("click", ".js-close-options", (event) => {
			event.preventDefault();
			$(".js-cookie-options").slideUp();
			$(".js-cookiebar").slideDown();
		});

		$(".js-cookie-form").submit((event) => {
			event.preventDefault();
			if ($("#analytics-cookie").is(":checked")) {
				optInGoogleTracking();
			} else {
				setCookie("_ga", undefined);
				setCookie("ga_optin", false, 182);
			}
			$(".js-cookie-options").slideUp();

		});

		$(document).on("click", ".js-ga-opt-in", (event) => {
			event.preventDefault();
			optInGoogleTracking();
			$(".js-cookiebar").slideUp();
		});
	}





// Set Scrollbar Width and 100VH Variable
// -----------------------------------------------------------------------------

	function setScrollbarWidthVariable() {
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty("--scrollbar", `${scrollbarWidth}px`);
	}

	function set100VHVariable() {
		const windowHeight = window.innerHeight;
		if (windowWidth !== previousWindowWidthForHeight) {
			previousWindowWidthForHeight = windowWidth;
			document.documentElement.style.setProperty("--vh", `${windowHeight}px`);
		}
	}





// Menu Fixed on Scroll
// -----------------------------------------------------------------------------

	function menuOnScroll() {
		const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop || 0;
		const headerHeight = $(".js-header").outerHeight();

		if ($("body").hasClass("home")) {
			if (scrollPosition > headerHeight) {
				$(".js-header").css("background-color", "#ffd700");
			} else {
				$(".js-header").css("background-color", "");
			}
		}
	}




// Toggle Menu & Submenus
// -----------------------------------------------------------------------------

	function closeMenu() {
		$("html").removeClass("menu-is-open");
		bodyScrollLock.clearAllBodyScrollLocks();
	}

	function toggleMenu() {
		$(".js-menu-toggle").click((event) => {
			event.preventDefault();
			if ($("html").hasClass("menu-is-open")) {
				closeMenu();
			} else {
				$("html").addClass("menu-is-open");
				bodyScrollLock.disableBodyScroll($(".js-navigation").get(0), {
					reserveScrollBarGap: true,
				});
			}
		});

		$(".c-header__nav--mobile .menu .menu-item-has-children a").click(function (event) {
			event.preventDefault();

			if ($(this).parent().hasClass("is-active")) {
				$(".c-header__nav--mobile .menu .menu-item-has-children .sub-menu").slideUp();
				$(".c-header__nav--mobile .menu .menu-item-has-children").removeClass("is-active");
			} else {
				$(".c-header__nav--mobile .menu .menu-item-has-children").removeClass("is-active");
				$(this).parent().addClass("is-active");
				$(".c-header__nav--mobile .menu .menu-item-has-children .sub-menu").slideUp();
				$(this).next().slideDown();
			}
		});
	}



// Submenu
// -----------------------------------------------------------------------------

	function openSubmenus() {
		$(".menu-item-has-children").hover(function () {
			$(this).find(".sub-menu").addClass("is-visible");
		}, function () {
			$(this).find(".sub-menu").removeClass("is-visible");
		});

		$(".c-header__nav--desktop .menu .menu-item-has-children a").click((event) => {
			event.preventDefault();
		});
	}




// Set Footer Placeholder Height
// -----------------------------------------------------------------------------

	function setFooterPlaceholderHeight() {
		if ($(".js-footer:visible").length) {
			const footerHeight = $(".js-footer").outerHeight();
			document.documentElement.style.setProperty("--footer-height", `${footerHeight}px`);
			$(".js-footer-placeholder").css("height", `${footerHeight - 1}px`);
		}
	}





// Footer Shadow
// -----------------------------------------------------------------------------

	function getFooterOpacity(modifier = 0) {
		const scrollPos = document.documentElement.scrollTop || document.body.scrollTop || 0;
		const footerHeight = $(".js-footer").outerHeight();
		const documentHeight = document.documentElement.offsetHeight;
		const windowHeight = window.innerHeight;
		const otherValue = modifier;
		const pageBottom = (documentHeight - windowHeight);
		let overlayOpacity;

		if (scrollPos > pageBottom + otherValue - (footerHeight * 0.75)) {
			overlayOpacity = (pageBottom + otherValue - scrollPos) / (footerHeight * 0.75);
			overlayOpacity = overlayOpacity < 0.1 ? 0 : overlayOpacity;
		} else {
			overlayOpacity = 1;
		}

		return overlayOpacity;
	}

	function footerShadow() {
		if ($(".js-footer:visible").length) {
			$(".js-footer-overlay").css("opacity", getFooterOpacity());
		}
	}




// Footer Newsletter Toggle
// -----------------------------------------------------------------------------

	function footerNewsletterToggle() {
		$(document).on("click", ".js-newsletter-toggle", (event) => {
			event.preventDefault();
			const newsletterHeight = $(".js-newsletter-wrapper .g-container").outerHeight();
			const animationSettings = { duration: 600, easing: "swing" };
			if ($(".js-newsletter-wrapper").height() === 0) {
				$(".js-newsletter-wrapper").animate({ height: newsletterHeight }, animationSettings);
				$(".js-footer-overlay").animate({ opacity: getFooterOpacity(newsletterHeight) }, animationSettings);
			} else {
				$(".js-newsletter-wrapper").animate({ height: 0 }, animationSettings);
				$(".js-footer-overlay").animate({ opacity: getFooterOpacity(-newsletterHeight) }, animationSettings);
			}
		});
	}



// In View
// -----------------------------------------------------------------------------

	function isScrolledIntoView(elem) {
		const docViewTop = $(window).scrollTop();
		const docViewBottom = docViewTop + $(window).height() * 0.9;
		const elemTop = $(elem).offset().top;
		const elemBottom = elemTop + $(elem).height();
		return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
	}

	function inView() {
		$(".js-scrollFade, .js-wysiwyg-scrollFade > *").not(".js-wysiwyg-scrollFade--Ignore").each(function () {
			if (isScrolledIntoView($(this))) {
				$(this).addClass("inView");
			}
		});
	}





// Creativity Quiz Functions
// -----------------------------------------------------------------------------

	function findOccurences(array) {
		if (array.length === 0) return null;
		const modeMap = {};
		let modes = [];
		let maxCount = 1;
		let i = 0;

		for (i = 0; i < array.length; i += 1) {
			const el = array[i];

			if (modeMap[el] == null) modeMap[el] = 1;
			else modeMap[el] += 1;

			if (modeMap[el] > maxCount) {
				modes = [el];
				maxCount = modeMap[el];
			} else if (modeMap[el] === maxCount) {
				modes.push(el);
				maxCount = modeMap[el];
			}
		}
		return modes;
	}

	function openBoxfromUrl() {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());

		if (Object.prototype.hasOwnProperty.call(params, "popup") && params.popup === "quiz") {
			$(".js-launch-creativity-popup-quiz")
				.eq(0)
				.focus()
				.click();
		}
	}

	function creativityQuiz() {
		$(".js-recipe-quiz-radio").off("change");
		$(document).off("click.quiz-next", ".js-creativity-quiz-next");
		$(document).on({
			"click.quiz-next": function (event) {
				event.preventDefault();
				const buttonParent = $(this).closest(".js-recipe-quiz-unit");
				buttonParent.hide();
				if (buttonParent.hasClass("js-recipe-quiz-intro")) {
					$(".js-recipe-quiz-form .js-recipe-quiz-unit:first-of-type").show();
					$(".js-recipe-quiz-radio").on("change", function () {
						if ($(this).is(":checked")) {
							$(this).closest(".js-recipe-quiz-unit").find(".js-creativity-quiz-next, .js-creativity-quiz-results").removeClass("c-cookbook-bottom-cta--disabled");
						} else {
							$(this).closest(".js-recipe-quiz-unit").find(".js-creativity-quiz-next, .js-creativity-quiz-results").addClass("c-cookbook-bottom-cta--disabled");
						}
					});
				} else {
					buttonParent.next().show();
				}
			},
		}, ".js-creativity-quiz-next");

		$(document).off("click.quiz-prev", ".js-creativity-quiz-prev");
		$(document).on({
			"click.quiz-prev": function (event) {
				event.preventDefault();
				const buttonParent = $(this).closest(".js-recipe-quiz-unit");
				buttonParent.hide();
				buttonParent.prev().show();
			},
		}, ".js-creativity-quiz-prev");

		$(document).off("click.quiz-results", ".js-creativity-quiz-results");
		$(document).on({
			"click.quiz-results": function (event) {
				event.preventDefault();
				const formValues = [];
				const formValue = $(".js-recipe-quiz-form").serializeArray();
				$.each(formValue, function () {
					formValues.push(this.value);
				});
				const creativeType = findOccurences(formValues);
				$(".js-recipe-quiz-form").hide();
				if (creativeType.length === 1) {
					$(`.js-creativity-results[data-results="${creativeType[0]}"]`).show();
				} else {
					$(`.js-creativity-results[data-results="X"]`).show();
				}
			},
		}, ".js-creativity-quiz-results");

		openBoxfromUrl();
	}





// Fancybox
// -----------------------------------------------------------------------------

	function iOS() {
		return [
			"iPad Simulator",
			"iPhone Simulator",
			"iPod Simulator",
			"iPad",
			"iPhone",
			"iPod",
		].includes(navigator.platform)
		// iPad on iOS 13 detection
		|| (navigator.userAgent.includes("Mac") && "ontouchend" in document);
	}

	function initFancybox() {
		if ($("body").hasClass("creativity-cookbook-landing-page") || $("body").hasClass("drawings-landing-page")) {
			const fancyboxScript = $(".js-fancybox-load").data("script");
			$.getScript(fancyboxScript, () => {
				$("[data-fancybox]").fancybox({
					beforeShow: (instance, current) => {
						if ("URLSearchParams" in window && $(current.opts.$orig).hasClass("js-launch-creativity-popup-quiz")) {
							const searchParams = new URLSearchParams(window.location.search);
							searchParams.set("popup", "quiz");
							const newRelativePathQuery = `${window.location.pathname}?${searchParams.toString()}`;
							window.history.pushState(null, "", newRelativePathQuery);
						}
					},
					beforeClose: () => {
						const thisHref = window.location.href;
						const url = thisHref.split("?");
						window.history.pushState(null, null, url[0]);
					},
				});
				creativityQuiz();
			});
		}
		if ($("body").hasClass("home")) {
			let fancyPlayer;
			const fancyboxScript = $(".js-fancybox-load").data("script");

			$.getScript(fancyboxScript, () => {
				$(".js-showreel-toggle").click((event) => {
					event.preventDefault();

					$.fancybox.open({
						src: "#showreel",
						toolbar: true,
						smallBtn: false,
						backFocus: false,
						idleTime: 0,
						hash: false,

						btnTpl: {
							close:
								"<button data-fancybox-close class='fancybox-button fancybox-button--close' title='{{CLOSE}}'></button>",
						},

						beforeShow: (instance) => {
							const thisPlayer = $(instance.current.src).find(".js-fancy-player");
							if (thisPlayer.length) {
								fancyPlayer = new Plyr(thisPlayer, videoPlayerOptions);
								fancyPlayer.on("ended", () => {
									$.fancybox.close();
								});

								if (!iOS()) {
									fancyPlayer.on("ready", () => {
										fancyPlayer.play();
										$(".js-showreel").addClass("is-loaded");
									});
								} else {
									$(".js-showreel").addClass("is-loaded");
								}
							}
							if (!aspectRatioIsSupported) {
								const fancyWidth = $(".fancybox-slide").width();
								const fancyHeight = $(".fancybox-slide").height();
								const fancyRatio = fancyWidth / fancyHeight;
								if (fancyRatio > (16 / 9)) {
									$(".js-showreel").width((fancyHeight / 9) * 16);
								} else {
									$(".js-showreel").width(fancyWidth);
								}
							}
						},

						afterClose: () => {
							if (fancyPlayer !== undefined) {
								fancyPlayer.destroy();
								$(".js-showreel").removeClass("is-loaded");
								fancyPlayer = undefined;
							}
						},
					});

				});
			});

		}
	}





// Close Recipe Fancybox on Background Click
// -----------------------------------------------------------------------------

	function closeRecipeFancybox() {
		$(document).on("click", ".js-recipe-underlay", (event) => {
			event.preventDefault();
			$.fancybox.close(true);
		});
	}





// Slick
// -----------------------------------------------------------------------------

	function selectedSlickPosition(slider) {
		const slideCount = slider.find(".o-slide").length;
		if ((window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) && (slideCount > 1)) {
			const slideWidth = slider.find(".o-slide").outerWidth();
			slider.find(".slick-track").css("left", `-${slideWidth / 2}px`);
		} else {
			slider.find(".slick-track").css("left", "");
		}
	}

	function setSlickArrowPosition(slider) {
		if (slider.find(".slick-arrow").length) {
			if (slider.hasClass("js-slideshow--cards")) {
				let maxHeight = 0;
				const cards = slider.find(".o-slide__card");

				$(cards).each(function () {
					const thisH = $(this).outerHeight();
					if (thisH > maxHeight) {
						maxHeight = thisH;
					}
				});

				slider.find(".slick-arrow").css("top", `${maxHeight / 2}px`);
			} else {
				const imageHeight = slider.find(".o-slide .o-block__image").outerHeight();
				slider.find(".slick-arrow").css("top", `${imageHeight / 2}px`);
			}
		}
	}

	function slickOnResize() {
		if ($(".js-slideshow").length) {
			$(".js-slideshow").each(function () {
				if ($(this).hasClass("js-slideshow--selected") || $(this).hasClass("js-slideshow--work-portrait")) {
					selectedSlickPosition($(this));
				}
				setSlickArrowPosition($(this));
			});
		}
	}


	function initSlick() {
		$(".js-slideshow").each(function () {
			if ($(this).hasClass("js-slideshow--work")) {
				let currentSlide;
				let slidesCount;
				const sliderCounter = document.createElement("div");
				sliderCounter.classList.add("c-work-slide-counter__inside");

				const updateSliderCounter = function (slick, currentIndex) {
					currentSlide = currentIndex + 1;
					slidesCount = slick.slideCount;
					$(sliderCounter).html(`<span>${currentSlide}</span><span class="c-work-slide-counter__bullet">&bull;</span><span>${slidesCount}</span>`);
				};

				$(this).on("init", (event, slick) => {
					$(this).parent().find(".c-work-slide-counter").append(sliderCounter);
					updateSliderCounter(slick, 0);
					if ($(this).hasClass("js-slideshow--work-portrait")) {
						selectedSlickPosition($(this));
					}
				});

				$(this).on("afterChange", (event, slick, currentSlideFunc) => {
					updateSliderCounter(slick, currentSlideFunc);
				});

				$(this).slick({
					inifinite: true,
					centerMode: true,
					variableWidth: true,
				});
			} else if ($(this).hasClass("js-slideshow--selected")) {
				$(this).on("init", () => {
					selectedSlickPosition($(this));
					setSlickArrowPosition($(this));
				});

				$(this).slick({
					inifinite: true,
					centerMode: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: true,
					responsive: [
						{
							breakpoint: lgBreakpoint,
							settings: {
								slidesToShow: 2,
							},
						},
					],
				});
			} else {
				$(this).on("init", () => {
					setSlickArrowPosition($(this));
				});

				$(this).slick({
					inifinite: true,
					centerMode: true,
					variableWidth: true,
				});
			}
		});
	}





// Scroll to Next Section
// -----------------------------------------------------------------------------

	function scrollToSection() {
		$(".js-scroll-to-section").click(function (event) {
			event.preventDefault();
			const headerHeight = $(".js-header").outerHeight();
			$("html, body").animate({
				scrollTop: ($($.attr(this, "href")).offset().top - headerHeight),
			}, 500);
		});
	}



// Ticker
// -----------------------------------------------------------------------------

	function generateTicker(tickerElement) {
		const tickerBlock = tickerElement.find(".js-ticker-block");
		const tickerGroup = tickerElement.find(".js-ticker-group");
		const tickerBlockWidth = tickerBlock.outerWidth();

		const iterations = Math.ceil(windowWidth / tickerBlockWidth);
		for (let i = 0; i < iterations; i += 1) {
			tickerBlock.clone().insertAfter(tickerBlock);
		}
		tickerGroup.clone().insertAfter(tickerGroup);
		tickerElement.find("img").each(function () {
			lazyLoadInstance.load($(this).get(0));
		});

		setTimeout(() => {
			const tickerSpeed = tickerElement.find(".js-ticker-group").width() / 40;
			tickerElement.find(".js-ticker-group").css("animation", `ticker-animation ${tickerSpeed}s infinite linear`);
		}, 0);
	}

	function ticker() {
		if (windowWidth !== previousWindowWidth) {
			previousWindowWidth = windowWidth;
			$(".js-ticker:visible").each(function () {
				const tickerElement = $(this);
				tickerElement.find(".js-ticker-block").not(":first").remove();
				tickerElement.find(".js-ticker-group").not(":first").remove();
				tickerElement.find(".js-ticker-group").css("animation", "");
				generateTicker(tickerElement);
			});
		}

	}



// Home Intro on Scroll
// -----------------------------------------------------------------------------

/*
	function homeIntroOnScroll() {
		if ($("body").hasClass("home")) {
			const scrollPosition = document.documentElement.scrollTop;
			gsap.to($(".js-home-intro-inside"), {
				y: scrollPosition / 3,
			});
		}
	}
*/





// Init Selectric
// -----------------------------------------------------------------------------

	function initSelectric() {
		$(".js-selectric, .wpcf7-select").selectric(selectricOptions);
	}




// Init Videos
// -----------------------------------------------------------------------------

	function initVideos() {
		Array.from(document.querySelectorAll(".js-plyr")).map(
			(p) => {
				let videoRatio = $(p).data("ratio");
				videoRatio = videoRatio || "16:9";
				const videoRatioArray = { ratio: videoRatio };
				const videoPlayerOptionsWithRatio = Object.assign({}, videoRatioArray, videoPlayerOptions); // eslint-disable-line
				return new Plyr(p, videoPlayerOptionsWithRatio);
			},
		);
	}





// Set Video Size
// -----------------------------------------------------------------------------

	function setVideoSize() {
		$("video").each(function () {
			if (!$(this).data("src")) {
				let src;

				if ($(this).hasClass("js-home-intro-video")) {
					if (window.matchMedia("(max-aspect-ratio: 1 / 1)").matches) {
						if (window.innerWidth > 450) {
							src = $(this).data("portrait-1170");
						} else {
							src = $(this).data("portrait-450");
						}

					} else {
						src = $(this).data("landscape-2560");
						if (window.innerWidth > 1280) {
							src = $(this).data("landscape-2560");
						} else {
							src = $(this).data("landscape-1280");
						}
					}
				} else if (window.matchMedia(`(min-width: ${lgBreakpoint})`).matches) {
					src = $(this).data("2560");
				} else {
					src = $(this).data("1280");
				}
				$(this).attr("data-src", src);
			}
		});
	}




// On Filter Change
// -----------------------------------------------------------------------------

	function setDropdownAsActive(dropdown) {
		const filterValue = dropdown.val();
		const filterParent = dropdown.parent().parent();
		if (filterValue !== "*") {
			$(filterParent).addClass("is-active");
		} else {
			$(filterParent).removeClass("is-active");
		}
	}

	function filterWorks(changeSelect) {
		const urlSearchParams = new URLSearchParams(window.location.search);
		const params = Object.fromEntries(urlSearchParams.entries());
		const filters = [];
		let classToFilter = [];

		$(".js-category-filters").each(function () {
			filters.push($(this).attr("name"));
		});

		if (changeSelect === true) {
			$(".js-selectric").each(function () {
				$(this).val("*");
			});
		}

		Object.keys(params).forEach((key) => {
			if (!filters.includes(key)) {
				return;
			}

			classToFilter.push(`.${key}-${params[key]}`);

			if (changeSelect === true) {
				$(`.js-selectric[name=${key}]`).val(params[key]);
			}
		});
		classToFilter = classToFilter.join("");

		if (changeSelect === true) {
			$(".js-selectric").selectric("refresh");
			$(".js-selectric").each(function () {
				setDropdownAsActive($(this));
			});
		}

		if (classToFilter === "") {
			$(".js-work").show();
		} else {
			$(".js-work").not(classToFilter).hide();
			$(`${classToFilter}.js-work`).show();
		}

		if (!$(`${classToFilter}.js-work`).length) {
			$(".js-no-results").show();
		} else {
			$(".js-no-results").hide();
		}
	}

	function filterWorksOnLoad() {
		if ($("body").hasClass("page-template-page-works")) {
			filterWorks(true);
			$(document).on("click", ".js-clear-filters", (event) => {
				event.preventDefault();
				window.history.replaceState({}, "", window.location.pathname);
				filterWorks(true);
			});
		}
	}

	function setFiltersStrings() {
		const params = new URLSearchParams(window.location.search);
		$(".js-selectric").each(function () {
			const filterValue = $(this).val();
			const filterName = $(this).attr("name");
			if (filterValue !== "*") {
				params.set(filterName, filterValue);
			} else {
				params.delete(filterName);
			}
		});
		if (!params.toString().length) {
			window.history.replaceState({}, "", window.location.pathname);
		} else {
			window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
		}

		filterWorks(false);
	}

	function onFilterChange() {
		$(".js-selectric").on("change", function () {
			setDropdownAsActive($(this));
			setFiltersStrings();
		});
	}





// Sticky Toolbar
// -----------------------------------------------------------------------------

	function stickyToolbar() {
		if ($("body").hasClass("single-works")) {
			$(".js-work-nav").appendTo(".js-header-wrapper");
		} else {
			$(".js-work-nav").remove();
		}
	}





// Home Eyes
// -----------------------------------------------------------------------------

	function isTouchDevice() {
		return (("ontouchstart" in window)
		|| (navigator.maxTouchPoints > 0)
		|| (navigator.msMaxTouchPoints > 0));
	}

	function moveEyes(xPosFunc, yPosFunc, xEyeLimit, yEyeLimit, eyeOuterMiddle, time) {

		crossEyed = false;

		let yPos = yPosFunc;
		let xPos = xPosFunc;

		if (yPos > xEyeLimit) {
			yPos = xEyeLimit;
		} else if (yPos < -xEyeLimit) {
			yPos = -xEyeLimit;
		}

		if (xPos > xEyeLimit) {
			xPos = xEyeLimit;
		} else if (xPos < -xEyeLimit) {
			xPos = -xEyeLimit;
		} else if (xPos < 4 && xPos > -4 && yPos < 5 && yPos > -5) {
			xPos = xEyeLimit;
			crossEyed = true;
		}

		if (Math.abs(xPos) + Math.abs(yPos) > eyeOuterMiddle) {
			const posSum = Math.abs(xPos) + Math.abs(yPos);
			const surplus = (eyeOuterMiddle - posSum) / 2;
			xPos = xPos > 0 ? xPos + surplus : xPos - surplus;
			yPos = yPos > 0 ? yPos + surplus : yPos - surplus;
		}

		if (crossEyed === true) {
			gsap.to(".js-left-eye-inner", time, {
				x: xPos,
				y: yPos,
			});
			gsap.to(".js-right-eye-inner", time, {
				x: -xPos,
				y: yPos,
			});
		} else {
			gsap.to(".js-eye-inner", time, {
				x: xPos,
				y: yPos,
			});
		}
	}

	function Timer(callback, delay) {
		let timerId;
		let start;
		let remaining = delay;

		this.pause = function () {
			window.clearTimeout(timerId);
			remaining -= Date.now() - start;
		};

		this.resume = function () {
			start = Date.now();
			window.clearTimeout(timerId);
			timerId = window.setTimeout(callback, remaining);
		};

		this.stop = function () {
			window.clearTimeout(timerId);
		};

		this.resume();
	}

	function autoEyes(time, xEyeLimit, yEyeLimit, eyeOuterMiddle) {
		const yPos = Math.floor(Math.random() * (yEyeLimit * 2)) - yEyeLimit;
		const xPos = Math.floor(Math.random() * (yEyeLimit * 2)) - yEyeLimit;
		moveEyes(xPos, yPos, xEyeLimit, yEyeLimit, eyeOuterMiddle, (time / 1000));
	}

	function homeEyes() {
		if ($("body").hasClass("home")) {

			let timeout;

			const eyesWidth = $(".js-eyes").width();
			const eyesHeight = $(".js-eyes").height();

			const eyeOuter = $(".js-eye-outer").get(0);
			const eyeOuterBox = eyeOuter.getBBox();
			const eyeOuterMiddle = eyeOuterBox.height / 2;

			const eyeInner = $(".js-eye-inner").get(0);
			const eyeInnerBox = eyeInner.getBBox();

			const eyesOffsetLeft = $(".js-eyes").offset().left;
			const eyesOffsetTop = $(".js-eyes").offset().top;

			const containerWidth = $(".js-eyes-wrapper").width();
			const contaierOffsetLeft = $(".js-eyes-wrapper").offset().left;

			const xCenter = eyesOffsetLeft + eyesWidth / 2;
			const xMouseLimit = containerWidth + contaierOffsetLeft;
			const xMouseRange = xMouseLimit - xCenter;
			const xEyeLimit = (eyeOuterBox.height - eyeInnerBox.height) / 2;

			const yCenter = eyesOffsetTop + eyesHeight / 2;
			const yEyeLimit = xEyeLimit;

			clearInterval(blinkingInterval);
			blinkingInterval = setInterval(() => {
				if (!isPaused) {
					$(".js-eyes-wrapper").css("clip-path", "inset(100% 0 0 0)");
					setTimeout(() => {
						$(".js-eyes-wrapper").css("clip-path", "inset(0 0 0 0)");
					}, 300);
				}
			}, 7000);

			if (isTouchDevice() !== true) {

				function cursorEyes(e) { //eslint-disable-line
					const relX = e.pageX;
					const relY = e.pageY;
					const xPos = ((xEyeLimit / xMouseRange) * relX) - ((xEyeLimit / xMouseRange) * xCenter);
					const yPos = ((yEyeLimit / yCenter) * relY) - yEyeLimit;
					moveEyes(xPos, yPos, xEyeLimit, yEyeLimit, eyeOuterMiddle, 0.3);
				}

				$(window).unbind("mousemove");
				$(window).mousemove((e) => {
					if (timeout) clearTimeout(timeout);
					timeout = setTimeout(cursorEyes.bind(null, e));
				});

			} else {

				(function loop() {
					const rand = Math.round(Math.random() * (2000 - 1250)) + 1250;
					const time = Math.round(Math.random() * (1250 - 350)) + 350;
					if (typeof autoEyesInterval !== "undefined") {
						autoEyesInterval.stop();
					}
					autoEyesInterval = new Timer(() => {
						autoEyes(time, xEyeLimit, yEyeLimit, eyeOuterMiddle);
						loop();
					}, rand);
				}());

			}

			$(".js-eyes").click(() => {

				isPaused = true;
				let savedLeftX = 0;
				let savedRightX = 0;
				let savedY = 0;

				if (typeof autoEyesInterval !== "undefined") {
					autoEyesInterval.pause();
				} else {
					savedLeftX = gsap.getProperty($(".js-eye-inner").get(0), "x");
					savedRightX = gsap.getProperty($(".js-eye-inner").get(1), "x");
					savedY = gsap.getProperty($(".js-eye-inner").get(0), "y");
				}

				gsap.to(".js-eye-inner", 0.3, {
					x: 0,
					y: yEyeLimit,
				}).eventCallback("onComplete", () => {
					$(".js-left-eye, .js-right-eye").addClass("go-crazy");
					setTimeout(() => {
						$(".js-left-eye, .js-right-eye").removeClass("go-crazy");
						isPaused = false;
						if (typeof autoEyesInterval !== "undefined") {
							autoEyesInterval.resume();
						} else {
							gsap.to(".js-left-eye-inner", 0.3, {
								x: savedLeftX,
								y: savedY,
							});
							gsap.to(".js-right-eye-inner", 0.3, {
								x: savedRightX,
								y: savedY,
							});
						}
					}, 1500);
				});

			});

		}
	}





// Scroll to Hash
// -----------------------------------------------------------------------------

	function scrollToHash() {

		if (window.location.hash && $(window.location.hash).length) {
			const hash = window.location.hash.substring(1);
			const hashTop = $(`#${hash}`).offset().top;
			const headerHeight = $(".js-header").outerHeight();
			$("html, body").animate({
				scrollTop: (hashTop - headerHeight),
			}, 0);
			history.pushState("", document.title, window.location.pathname + window.location.search); // eslint-disable-line
		}
	}





// Check If Flexbox is Supported
// -----------------------------------------------------------------------------


	function checkFlexGap() {
		// create flex container with row-gap set
		const flex = document.createElement("div");
		flex.style.display = "flex";
		flex.style.flexDirection = "column";
		flex.style.rowGap = "1px";

		// create two, elements inside it
		flex.appendChild(document.createElement("div"));
		flex.appendChild(document.createElement("div"));

		// append to the DOM (needed to obtain scrollHeight)
		document.body.appendChild(flex);
		// flex container should be 1px high from the row-gap
		const isSupported = flex.scrollHeight === 1;
		flex.parentNode.removeChild(flex);

		return isSupported;
	}

	function ifFlexGap() {
		if (checkFlexGap()) {
			$("html").addClass("flexbox-gap");
		} else {
			$("html").addClass("no-flexbox-gap");
		}
	}





// Check If Aspect Ratio is Supported
// -----------------------------------------------------------------------------

	function aspectRatioPolyFill() {
		if (!aspectRatioIsSupported) {
			$(".o-featured-text .js-svg-element").not(".ratio-fixed").each(function () {
				const aspectRatio = $(this).data("ratio");
				const thisHeight = $(this).outerHeight();
				$(this).css("width", `${thisHeight * aspectRatio}px`);
				$(this).addClass("ratio-fixed");
			});
		}
	}





// 2023 Wishes Functions
// -----------------------------------------------------------------------------

	function wishesFunctions() {
		$(window).bind("scroll.wishes", () => {
			const windowHeight = window.innerHeight;
			const windowTop = $(window).scrollTop();
			const chairTop = $(".js-wishes-gifs.chaise").offset().top;
			const chairHeight = $(".js-wishes-gifs.chaise").outerHeight();

			if (windowHeight + windowTop > chairTop + chairHeight) {
				$(".js-wishes-gifs.chaise").addClass("is-pulled");
			} else {
				$(".js-wishes-gifs.chaise").removeClass("is-pulled");
			}
		});

		$(".js-wishes-button").unbind().click(function (event) {
			event.preventDefault();
			const checkedElement = $(this).parent().find(".js-wishes-radio:checked");
			const checkedIndex = checkedElement.data("index");
			let newIndex;

			if ($(this).hasClass("js-wishes-button--left")) {
				newIndex = (checkedIndex + 1) > 3 ? 1 : (checkedIndex + 1);
			} else {
				newIndex = (checkedIndex - 1) < 1 ? 3 : (checkedIndex - 1);
			}

			checkedElement.attr("checked", false);
			$(this).parent().find(`.js-wishes-radio[data-index="${newIndex}"]`).attr("checked", true);
		});
	}

	function wishesScroll() {
		if ($("body").hasClass("page-id-22675") || $("body").hasClass("page-id-22649")) {
			$(window).bind("scroll.wishes", () => {
				wishesFunctions();
			});
		} else {
			$(window).unbind(".wishes");
		}
	}




// Infrabel Academy Functions
// -----------------------------------------------------------------------------

	function academyFunctions(next) {
		if (!$("body").hasClass("postid-41090")) return; //WRONG

		lenis = new Lenis();

		lenis.on("scroll", ScrollTrigger.update);

		gsap.ticker.add((time) => {
			lenis.raf(time * 1000);
		});

		gsap.ticker.lagSmoothing(0);

		const headerHeight = $(".js-header-wrapper").outerHeight();

		const hero = $(".js-ia-hero").get(0);
		const heroLogo = $(hero).find(".js-ia-hero-logo").get(0);
		const heroVegetation = $(hero).find(".js-ia-hero-vegetation-1").get(0);
		const smallVegetationLeft = $(hero).find(".js-ia-hero-vegetation-2").get(0);
		const smallVegetationRight = $(hero).find(".js-ia-hero-vegetation-3").get(0);
		const leftTrain = $(".js-ia-train-left").get(0);
		const rightTrain = $(".js-ia-train-right").get(0);
		const logoTranslateY = "-20vh";
		const vegetationTranslateY = "-10vh";
		//const overlay = hero.find(".js-hero-overlay");
		//const scroller = currentContainer.hasClass("single") ? currentContainer : false;
		//const translateY = window.matchMedia(`(min-width: ${lgBreakpoint})`).matches ? -12.5 : -25;

		const heroTl = gsap.timeline();
		heroTl.to(heroLogo, { y: "-20vh", duration: 1, ease: "none" });
		heroTl.to(smallVegetationLeft, { y: "-25vh", duration: 1, ease: "none" }, "<");
		heroTl.to(smallVegetationRight, { y: "-60vh", duration: 1, ease: "none" }, "<");
		heroTl.to(heroVegetation, { y: "-15vh", duration: 1, ease: "none" }, "<");
		heroTl.to(leftTrain, { x: "-60vw", duration: 1, ease: "none" }, "<");
		heroTl.to(rightTrain, { x: "60vw", duration: 1, ease: "none" }, "<");

		const scrollTriggerOptions = {
			animation: heroTl,
			trigger: hero,
			start: `${-headerHeight} top`, //WRONG
			end: "bottom top",
			pin: true,
			pinSpacing: false,
			scrub: true,
			invalidateOnRefresh: true,
		};

		ScrollTrigger.create(scrollTriggerOptions);

		let proxyRight = { skew: 0 },
		proxyLeft = { skew: 0 },
		skewSetterRight = gsap.quickSetter(".js-scroll-vegetation-right img", "skewY", "deg"), // fast
		skewSetterLeft = gsap.quickSetter(".js-scroll-vegetation-left img", "skewY", "deg"), // fast
		clamp = gsap.utils.clamp(-50, 50); // don't let the skew go beyond 20 degrees.

		ScrollTrigger.create({
			onUpdate: (self) => {
				let skew = clamp(self.getVelocity() / -100);
				// only do something if the skew is MORE severe. Remember, we're always tweening back to 0, so if the user slows their scrolling quickly, it's more natural to just let the tween handle that smoothly rather than jumping to the smaller skew.
				if (Math.abs(skew) > Math.abs(proxyRight.skew)) {
					proxyRight.skew = skew;
					proxyLeft.skew = -skew;
					gsap.to(proxyRight, {skew: 0, duration: 0.8, ease: "power3", overwrite: true, onUpdate: () => skewSetterRight(proxyRight.skew)});
					gsap.to(proxyLeft, {skew: 0, duration: 0.8, ease: "power3", overwrite: true, onUpdate: () => skewSetterLeft(proxyLeft.skew)});
				}
			}
		});

		// make the right edge "stick" to the scroll bar. force3D: true improves performance
		gsap.set(".js-scroll-vegetation img", {force3D: true});

		const aboutMedia = $(".js-section-3-video").get(0);
		const windowHeight = window.innerHeight;

		ScrollTrigger.create({
			animation: gsap.fromTo(aboutMedia, { scale: 0.5 }, {
				scale: 1,
				ease: "none",
			}),
			trigger: aboutMedia,
			start: () => `center+=${-headerHeight / 2} center`, //TAKE MENU INTO CONSIDERATION
			end: () => `+=${windowHeight / 2}`,
			scrub: true,
			pin: true,
			pinSpacing: true,
			invalidateOnRefresh: true,

			onLeave: () => {
				$(aboutMedia).find("video").get(0).play();
			}
		});

		const trackTrain = $(".js-ia-track-train").get(0);

		ScrollTrigger.create({
			animation: gsap.to(trackTrain, {
				x: "60vw",
				ease: "none",
			}),
			trigger: trackTrain,
			start: "top bottom",
			end: "bottom top",
			scrub: true,
			invalidateOnRefresh: true,
		});


	}



// Load Forms
// -----------------------------------------------------------------------------

	function onCampaignFormSubmit() {
		let hasRedirected = false;

		if ($("body").hasClass("icebreaker-landing-page")) {
			setCookie("icebreaker", true, 365);
			location.reload(); // eslint-disable-line
			window.scrollTo(0, 0);
		} else if ($("body").hasClass("technograms-landing-page")) {
			setCookie("technograms", true, 365);
			location.reload(); // eslint-disable-line
			window.scrollTo(0, 0);
		} else if ($("body").hasClass("creativity-cookbook-landing-page")) {
			setCookie("cookbook", true, 365);
			location.reload(); // eslint-disable-line
			window.scrollTo(0, 0);
		} else if ($("body").hasClass("elearning-landing-page")) {
			setCookie("learning", true, 365);
			location.reload(); // eslint-disable-line
			window.scrollTo(0, 0);
		} else if ($("body").hasClass("drawings-landing-page")) {
			setCookie("drawings", true, 365);
			location.reload(); // eslint-disable-line
			window.scrollTo(0, 0);
		} else if ($("body").hasClass("miroverse-landing-page")) {
			const formRedirect = $(".js-campaign-form").data("redirect");
			setCookie("miroverse", true, 365);
			if (hasRedirected === false) {
				hasRedirected = true;
				const newWindow = window.open(formRedirect, "_blank");
				if (newWindow) {
					newWindow.focus();
				}

			}
			location.reload(); // eslint-disable-line
			window.scrollTo(0, 0);
		}
	}

	function campaignForms() {
		if ($(".js-campaign-form").length) {
			const mailList = $(".js-campaign-form").data("list");
			const formCTA = $(".js-campaign-form").data("cta");

			$(".js-campaign-form .js-form-list input").val(mailList);
			$(".js-campaign-form input[type='submit']").val(formCTA);

			$(".js-campaign-form").get(0).removeEventListener("wpcf7mailsent", onCampaignFormSubmit, false);
			$(".js-campaign-form").get(0).addEventListener("wpcf7mailsent", onCampaignFormSubmit, false);
		}
	}

	function loadForms(next) {
		const formSelector = "div.wpcf7 > form";
		const forms = $(next).find(formSelector);
		if (forms.length > 0) {
			$(formSelector).each(function () {
				const form = $(this);
				wpcf7.init(form[0]);
				wpcf7cf.initForm(form);
			});
		}

		observer = new MutationObserver(() => {
			storeAndOutputCookies();
			campaignForms();
		});

		$("form").each(function () {
			observer.observe($(this).get(0), {
				attributes: true,
			});
		});


	}





// Page Load Functions
// -----------------------------------------------------------------------------

	function pageLoadFunctions(next) {
		previousWindowWidth = 0;
		clearInterval(blinkingInterval);
		$(window).unbind("mousemove");
		$(".js-footer-overlay").css("opacity", 1);
		if (observer) {
			observer.disconnect();
		}
		initSlick();
		inView();
		initSelectric();
		onFilterChange();
		filterWorksOnLoad();
		scrollToSection();
		initVideos();
		setVideoSize();
		menuOnScroll();
		stickyToolbar();
		wishesScroll();
		aspectRatioPolyFill();
		closeRecipeFancybox();
		loadForms(next);
		academyFunctions(next);
		lazyLoadInstance.update();
	}

	function afterLoadFunctions() {
		ticker();
		homeEyes();
		initFancybox();
		storeAndOutputCookies();
		campaignForms();
	}



// Barba
// -----------------------------------------------------------------------------

	function barbaInit() {
		barba.init({
			debug: false,
			cacheIgnore: false,
			// prefetchIgnore: true,
			timeout: 5000,
			transitions: [{
				name: "opacity-transition",
				sync: false,
				beforeLeave() {
					$("html").addClass("is-loading");
				},
				leave(data) {
					const done = this.async();

					if ($("html").hasClass("menu-is-open") && window.matchMedia(`(max-width: ${lgBreakpoint})`).matches) {
						if ($("html").hasClass("home")) {
							$(".js-header").css("background-color", "#ffd700");
						}

						return gsap.to(data.current.container, {
							opacity: 0,
							duration: 0,
							onComplete: () => {
								$(data.current.container).css("display", "none");
								closeMenu();
								$("html").addClass("menu-was-open");
								$(".js-footer").css("opacity", 0);
								done();
							},
						});
					}

					// ELSE

					$(".js-overlay").addClass("g-overlay--active");
					$(".js-shadow").addClass("g-shadow--active");

					gsap.fromTo($(".js-overlay").get(0), { x: "100%" }, {
						x: "0",
						duration: (pageTransitionTime / 2),
						ease: Quint.easeIn,
					});

					gsap.fromTo($(".js-shadow").get(0), { opacity: "0" }, {
						opacity: "1",
						duration: (pageTransitionTime / 2),
						ease: Quint.easeIn,
					});

					return gsap.to(data.current.container, {
						x: "-50%",
						duration: (pageTransitionTime / 2),
						ease: Quint.easeIn,
						onComplete: () => {
							$(data.current.container).css("display", "none");
							done();
						},
					});
				},
				beforeEnter(data) {
					const nextClass = $(data.next.container).data("barba-class");
					const nextID = $(data.next.container).data("barba-id");
					$("body").removeClass();
					$("body").addClass(nextClass);
					$(".menu-item").removeClass("current-menu-item current_page_item current-menu-ancestor current-menu-parent");
					$(`.menu-item-page-${nextID}`).addClass("current-menu-item current_page_item");
					if ($(`.menu-item-page-${nextID}`).parent().parent().hasClass("menu-item-has-children")) {
						$(`.menu-item-page-${nextID}`).parent().parent().addClass("current-menu-ancestor current-menu-parent");
					}
					$(".js-language").each(function () {
						const thisLanguage = $(this).data("language");
						const newUrl = $(data.next.container).data(thisLanguage);
						$(this).attr("href", newUrl);
					});
					if ($(".js-slideshow.slick-initialized").length !== 0) {
						$(".js-slideshow.slick-initialized").slick("unslick");
					}
					if ($(data.next.container).data("header-color")) {
						const headerBg = $(data.next.container).data("header-color");
						$(".js-header").css("background-color", headerBg);
					} else {
						$(".js-header").css("background-color", "#ffd700");
					}
					pageLoadFunctions(data.next.container);

					// THIS IS FOR DEBUGGING
					// return new Error('The key (' + key + ") isn't accessible: " + err);

					if ($(data.next.container).find(".js-back-button").length !== 0) {
						$(".js-back-button").attr("href", data.current.url.href);
					}

					previousPageScrollPositionSaved = document.documentElement.scrollTop;

					if (data.trigger.href !== undefined && data.trigger.href.indexOf("#") !== -1) {
						scrollToHash();
					} else if (data.trigger.href !== undefined) {
						window.scrollTo(0, 0);
					} else if (data.trigger === "back") {
						isBack = true;
						history.scrollRestoration = "manual"; // eslint-disable-line
					}
				},
				enter(data) {
					const done = this.async();

					// Scroll to section if Back button

					if (isBack) {
						window.scrollTo(0, previousPageScrollPosition);
						isBack = false;
					}
					previousPageScrollPosition = previousPageScrollPositionSaved;

					// IF

					if ($("html").hasClass("menu-was-open") && window.matchMedia(`(max-width: ${lgBreakpoint})`).matches) {
						return gsap.fromTo(data.next.container, { opacity: "0" }, {
							opacity: "1",
							duration: (pageTransitionTime / 2),
							onComplete: () => {
								$("html").removeClass("menu-was-open");
								$(".js-footer").css("opacity", 1);
								done();
							},
						});
					}

					// ELSE

					gsap.fromTo($(".js-overlay").get(0), { x: "0" }, {
						x: "-100%",
						duration: (pageTransitionTime / 2),
						ease: Quint.easeOut,
					});

					gsap.fromTo($(".js-shadow").get(0), { opacity: "1" }, {
						opacity: "0",
						duration: (pageTransitionTime / 2),
						ease: Quint.easeOut,
					});

					return gsap.fromTo(data.next.container, { x: "50%" }, {
						x: 0,
						duration: (pageTransitionTime / 2),
						ease: Quint.easeOut,
						onComplete: () => {
							$(data.next.container).css("transform", "none");
							done();
						},
					});
				},
				afterEnter() {
					$("html").removeClass("is-loading");
					$(".js-overlay").removeClass("g-overlay--active");
					$(".js-shadow").removeClass("g-shadow--active");
				},
			}],
		});

		barba.hooks.after(() => {
			afterLoadFunctions();
		});
	}



// Init
// -----------------------------------------------------------------------------

	$(document).ready(() => {
		previousWindowWidthForHeight = 0;
		aspectRatioIsSupported = CSS.supports("aspect-ratio", "1 / 1");
		windowWidth = $(window).width();
		initLazyLoad();
		setScrollbarWidthVariable();
		set100VHVariable();
		setFooterPlaceholderHeight();
		barbaInit();
		toggleMenu();
		openSubmenus();
		pageLoadFunctions();
		afterLoadFunctions();
		ifFlexGap();
		footerNewsletterToggle();
		initCookieBar();
		scrollToHash();
	});

	$(window).on("scroll", () => {
		menuOnScroll();
		footerShadow();
		inView();
	});

	$(window).on("resize", () => {
		windowWidth = $(window).width();
		setScrollbarWidthVariable();
		ticker();
		homeEyes();
		set100VHVariable();
		setFooterPlaceholderHeight();
		inView();
		slickOnResize();
	});

}(jQuery));
